import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationPlanMap, LocationWithPlan } from '../../../../types';

type CellParams = ICellRendererParams<LocationWithPlan> & {
  branchId: () => number;
  isEditing: () => boolean;
  editData: () => LocationPlanMap;
  allPlanNamesByPriceId: () => Record<string, string>;
  selfServePrices: () => Array<{ id: string; name: string }>;
  updatePlan: (location: LocationWithPlan, newPriceId: string | undefined) => void;
};

@Component({
  selector: 'app-pan-cell-billing-portal-cell-plan',
  imports: [UiModule, MatTooltipModule, RouterModule, NgSelectModule, ReactiveFormsModule, FormsModule],
  templateUrl: './billing-portal-cell-plan.component.html',
  styleUrl: './billing-portal-cell-plan.component.scss',
})
export class CellBillingPortalCellPlanComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  updateCurrentPlanData(location: LocationWithPlan, newPriceId: string | undefined) {
    this.params.updatePlan(location, newPriceId);
  }
}
